export default __webpack_public_path__ + "static/media/ic_info.c1525cda.svg";